import { render, staticRenderFns } from "./Dummy.vue?vue&type=template&id=dbdb2292&scoped=true&"
import script from "./Dummy.vue?vue&type=script&lang=ts&"
export * from "./Dummy.vue?vue&type=script&lang=ts&"
import style0 from "./Dummy.vue?vue&type=style&index=0&id=dbdb2292&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdb2292",
  null
  
)

export default component.exports